import './SectionCenterHeader.css';

const SectionCenterHeader = (props) => {
    return <h2 className='section-center-header primary-text'>{props.children}</h2>
};

export default SectionCenterHeader;